import React, { useEffect, useRef, useState } from 'react';

const InfoTooltip = ({ children, position = 'right', width = 'w-72', icon = '💁🏻‍♂️' }) => {
  const tooltipRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Responsive detection
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 640);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Hide on scroll
  useEffect(() => {
    const handleScroll = () => visible && setVisible(false);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [visible]);

  // Tooltip position classes
  const positionClasses = {
    right: 'left-6 top-0',
    left: 'right-6 top-0',
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
  };

  return (
    <div
      className="relative group inline-block"
      onMouseEnter={() => !isMobile && setVisible(true)}
      onMouseLeave={() => !isMobile && setVisible(false)}
      onTouchStart={() => setVisible(!visible)}
    >
      <span
        className="text-sm cursor-default select-none"
        aria-label="More info"
      >
<svg
  xmlns="http://www.w3.org/2000/svg"
  className="w-5 h-5 text-candy-primary"
  fill="none"
  viewBox="0 0 24 24"
  stroke="currentColor"
  strokeWidth={2}
  aria-hidden="true"
>
  <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M12 2a10 10 0 100 20 10 10 0 000-20z" />
</svg>
      </span>

      <div
        ref={tooltipRef}
        className={`
          absolute z-50 ${width} max-w-[90vw] p-4 bg-white border border-gray-300 rounded shadow-md text-xs text-gray-600
          ${isMobile ? 'left-1/2 top-full mt-2 -translate-x-1/2' : positionClasses[position]}
          ${visible ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}
          transition-opacity duration-200
        `}
        style={{
          wordWrap: 'break-word',
          boxSizing: 'border-box',
        }}
      >
        <div className="flex flex-col items-center text-center">{children}</div>
      </div>
    </div>
  );
};

export default InfoTooltip;
